<template>
  <div
    class="flex flex-col flex-1 bg-white fixed sideNavHeight"
    style="width: 285px; z-index: 3; border-right: 1px solid #c9cccf"
  >
    <div class="flex-1 flex flex-col pb-4">
      <nav
        v-if="!agency"
        class="mt-5 flex-1 px-4 bg-white space-y-1"
        aria-label="Sidebar"
      >
        <NavLink
          v-if="!data.publicProfilesOnly"
          path="/partners"
          label="Service partner profiles"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="m496 480h-11.507l-12.97-51.88c-1.782-7.123-8.181-12.12-15.523-12.12h-56v-24h48c8.837 0 16-7.164 16-16s-7.163-16-16-16v-8c0-100.481-77.59-183.17-176-191.328v-24.672h24c8.837 0 16-7.164 16-16s-7.163-16-16-16h-80c-8.837 0-16 7.164-16 16s7.163 16 16 16h24v24.672c-98.41 8.158-176 90.847-176 191.328v8c-8.837 0-16 7.164-16 16s7.163 16 16 16h48v24h-56c-7.342 0-13.741 4.997-15.522 12.12l-12.971 51.88h-11.507c-8.837 0-16 7.164-16 16s7.163 16 16 16h480c8.837 0 16-7.164 16-16s-7.163-16-16-16zm-400-128c0-88.224 71.775-160 160-160s160 71.776 160 160v8c-48.629 0-305.697 0-320 0zm48 40h224v24h-224zm-83.508 88 8-32h375.016l8 32z"
              />
              <path
                d="m16 272h32c8.837 0 16-7.164 16-16s-7.163-16-16-16h-32c-8.837 0-16 7.164-16 16s7.163 16 16 16z"
              />
              <path
                d="m464 272h32c8.837 0 16-7.164 16-16s-7.163-16-16-16h-32c-8.837 0-16 7.164-16 16s7.163 16 16 16z"
              />
              <path
                d="m97.608 120.236c6.248 6.248 16.379 6.249 22.627 0 6.249-6.249 6.249-16.379 0-22.627l-22.628-22.629c-6.248-6.248-16.379-6.249-22.627 0-6.249 6.249-6.249 16.379 0 22.627z"
              />
              <path
                d="m403.078 124.922c4.095 0 8.189-1.563 11.313-4.686l22.628-22.627c6.249-6.249 6.249-16.379 0-22.627-6.247-6.248-16.378-6.248-22.627 0l-22.628 22.627c-10.108 10.107-2.812 27.313 11.314 27.313z"
              />
              <path
                d="m256 64c8.837 0 16-7.164 16-16v-32c0-8.836-7.163-16-16-16s-16 7.164-16 16v32c0 8.836 7.163 16 16 16z"
              />
            </g>
          </svg>
        </NavLink>

        <NavLink
          v-if="!data.publicProfilesOnly"
          path="/contact-requests"
          label="Contact requests"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            enable-background="new 0 0 24 24"
            height="512"
            viewBox="0 0 24 24"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m21.75 23h-19.5c-1.241 0-2.25-1.009-2.25-2.25v-12.1c0-.833.457-1.593 1.191-1.985l9.75-5.2c.663-.354 1.455-.354 2.118 0l9.75 5.2c.734.392 1.191 1.152 1.191 1.985v12.1c0 1.241-1.009 2.25-2.25 2.25zm-9.75-20.3c-.121 0-.243.03-.353.088l-9.75 5.2c-.245.131-.397.385-.397.662v12.1c0 .414.336.75.75.75h19.5c.414 0 .75-.336.75-.75v-12.1c0-.277-.152-.531-.397-.662l-9.75-5.2c-.11-.059-.232-.088-.353-.088z"
            />
            <path
              d="m11.999 16.996c-.438 0-.875-.103-1.273-.309l-10.323-5.393c-.367-.191-.509-.645-.317-1.012s.646-.508 1.012-.317l10.32 5.39c.358.185.808.185 1.169-.002l10.317-5.388c.367-.192.82-.05 1.012.317s.05.82-.317 1.012l-10.32 5.39c-.403.208-.841.312-1.28.312z"
            />
          </svg>
        </NavLink>

        <NavLink
          v-if="!data.publicProfilesOnly"
          path="/matchmaking-requests"
          label="Matchmaking requests"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 456.559 456.559"
            style="enable-background:new 0 0 456.559 456.559;"
            xml:space="preserve"
          >
            <g>
              <path
                d="M351.79,151.874c-3.434,0-6.875-1.308-9.498-3.931c-5.238-5.245-5.238-13.75,0-18.995l53.02-53.006l-53.02-53.013 c-5.238-5.245-5.238-13.75,0-18.995c5.245-5.245,13.75-5.245,18.995,0l62.511,62.511c2.518,2.518,3.931,5.938,3.931,9.498 c0,3.56-1.413,6.98-3.931,9.498l-62.511,62.504C358.665,150.566,355.224,151.874,351.79,151.874z"
              />
              <path
                d="M42.958,227.428c-7.413,0-13.428-6.015-13.428-13.428v-80.932c0-38.907,31.647-70.554,70.554-70.554h314.218 c7.413,0,13.428,6.015,13.428,13.428c0,7.413-6.015,13.428-13.428,13.428H100.083c-24.094,0-43.697,19.604-43.697,43.697V214 C56.386,221.414,50.371,227.428,42.958,227.428z"
              />
              <path
                d="M357.162,394.049H42.258c-7.413,0-13.428-6.015-13.428-13.428s6.015-13.428,13.428-13.428h314.903 c24.101,0,43.704-19.604,43.704-43.697v-82.534c0-7.413,6.015-13.428,13.428-13.428c7.413,0,13.428,6.015,13.428,13.428v82.534 C427.722,362.402,396.068,394.049,357.162,394.049z"
              />
              <path
                d="M104.769,456.559c-3.434,0-6.875-1.308-9.498-3.931l-62.511-62.511c-2.518-2.518-3.931-5.938-3.931-9.498 s1.413-6.98,3.931-9.498l62.511-62.504c5.245-5.245,13.75-5.245,18.995,0c5.238,5.245,5.238,13.75,0,18.995l-53.02,53.006 l53.02,53.013c5.238,5.245,5.238,13.75,0,18.995C111.644,455.252,108.203,456.559,104.769,456.559z"
              />
            </g>
          </svg>
        </NavLink>

        <NavLink
          v-if="data.reviewsEnabled && !data.publicProfilesOnly"
          path="/reviews"
          label="Reviews"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            enable-background="new 0 0 512.07 512.07"
            height="512"
            viewBox="0 0 512.07 512.07"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="m509.759 194.639c-6.152-18.858-22.945-31.043-42.781-31.043h-127.918l-40.282-122.33c-6.192-18.805-22.95-30.926-42.729-30.926-.063 0-.128 0-.191.001-19.86.078-36.611 12.349-42.674 31.262l-39.108 121.993h-128.983c-19.886 0-36.692 12.226-42.814 31.146-6.123 18.92.335 38.674 16.453 50.324l104.361 75.434-40.17 121.991c-6.217 18.88.133 38.662 16.177 50.396 8.058 5.894 17.307 8.842 26.562 8.842 9.171-.001 18.347-2.897 26.365-8.693l104.542-75.563 103.3 75.436c16.026 11.704 36.781 11.76 52.873.147s22.575-31.328 16.518-50.227l-39.218-122.329 103.474-75.563c16.02-11.698 22.396-31.441 16.243-50.298zm-33.935 26.07-120.959 88.332 45.825 142.946c3.085 9.621-3.435 15.247-5.506 16.742s-9.465 5.91-17.625-.05l-120.901-88.289-122.206 88.333c-8.201 5.927-15.576 1.461-17.642-.05-2.065-1.511-8.558-7.187-5.392-16.8l47.033-142.833-122.145-88.287c-8.206-5.932-6.272-14.34-5.484-16.775s4.146-10.382 14.271-10.382h150.87l45.79-142.835c3.087-9.629 11.668-10.41 14.225-10.421h.052c2.62 0 11.113.769 14.255 10.309l47.07 142.947h149.624c10.1 0 13.469 7.92 14.261 10.348s2.74 10.81-5.416 16.765z"
              />
            </g>
          </svg>
        </NavLink>

        <NavLink
          v-if="data.integrationsEnabled && !data.publicProfilesOnly"
          path="/integration-partners"
          label="Technology partner profiles"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            enable-background="new 0 0 512.086 512.086"
            height="512"
            viewBox="0 0 512.086 512.086"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="m278.741 278.741-40.86 40.86-45.396-45.396 40.86-40.86-21.213-21.213-40.86 40.86-31.271-31.271-77.617 77.616c-36.291 36.291-37.314 94.688-3.087 132.237l-59.297 59.299 21.213 21.213 59.292-59.292c17.678 16.132 40.41 24.967 64.5 24.967 25.59 0 49.648-9.965 67.743-28.06l77.616-77.617-31.271-31.271 40.86-40.86zm-87.206 149.747c-12.429 12.428-28.953 19.273-46.53 19.273s-34.101-6.845-46.53-19.273l-14.877-14.878c-25.656-25.657-25.656-67.403 0-93.06l56.404-56.403 107.936 107.936z"
              />
              <path
                d="m512.086 21.213-21.213-21.213-59.292 59.292c-17.678-16.132-40.41-24.967-64.5-24.967-25.59 0-49.648 9.965-67.743 28.06l-77.616 77.617 150.362 150.362 77.617-77.616c36.291-36.291 37.314-94.689 3.087-132.237zm-83.598 170.322-56.404 56.403-107.936-107.936 56.403-56.404c12.429-12.428 28.953-19.273 46.53-19.273s34.101 6.845 46.53 19.273l14.877 14.877c25.656 25.657 25.656 67.403 0 93.06z"
              />
            </g>
          </svg>
        </NavLink>

        <NavLink
          path="/our-public-profiles"
          label="Our public profiles"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="m446.605 124.392-119.997-119.997c-2.801-2.802-6.624-4.395-10.608-4.395h-210c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45v-332c0-4.09-1.717-7.931-4.395-10.608zm-115.605-73.179 68.787 68.787h-53.787c-8.271 0-15-6.729-15-15zm75 430.787h-300c-8.271 0-15-6.729-15-15v-422c0-8.271 6.729-15 15-15h195v75c0 24.813 20.187 45 45 45h75v317c0 8.271-6.729 15-15 15z"
              />
              <path
                d="m346 212h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
              <path
                d="m346 272h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
              <path
                d="m346 332h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
              <path
                d="m286 392h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
            </g>
          </svg>
        </NavLink>

        <NavLink
          v-if="!data.publicProfilesOnly"
          path="/settings"
          label="Directory settings"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 456.556 456.556"
            style="enable-background:new 0 0 456.556 456.556;"
            xml:space="preserve"
          >
            <g>
              <path
                d="M97.564,79.443H13.428C6.011,79.443,0,73.428,0,66.015s6.011-13.428,13.428-13.428h84.136 c7.417,0,13.428,6.015,13.428,13.428S104.981,79.443,97.564,79.443z"
              />
              <path
                d="M145.643,127.518c-33.916,0-61.507-27.591-61.507-61.504c0-33.92,27.591-61.511,61.507-61.511s61.507,27.591,61.507,61.511 C207.15,99.928,179.559,127.518,145.643,127.518z M145.643,31.36c-19.107,0-34.651,15.547-34.651,34.654 s15.544,34.647,34.651,34.647s34.651-15.54,34.651-34.647S164.75,31.36,145.643,31.36z"
              />
              <path
                d="M443.128,79.443H242.433c-7.417,0-13.428-6.015-13.428-13.428s6.011-13.428,13.428-13.428h200.694 c7.417,0,13.428,6.015,13.428,13.428S450.545,79.443,443.128,79.443z"
              />
              <path
                d="M325.936,289.782c-33.917,0-61.507-27.591-61.507-61.504s27.591-61.504,61.507-61.504s61.507,27.591,61.507,61.504 S359.853,289.782,325.936,289.782z M325.936,193.631c-19.107,0-34.651,15.54-34.651,34.647s15.544,34.647,34.651,34.647 s34.651-15.54,34.651-34.647S345.043,193.631,325.936,193.631z"
              />
              <path
                d="M229.149,241.706H13.428C6.011,241.706,0,235.691,0,228.278s6.011-13.428,13.428-13.428h215.721 c7.417,0,13.428,6.015,13.428,13.428S236.566,241.706,229.149,241.706z"
              />
              <path
                d="M443.128,241.706h-69.113c-7.417,0-13.428-6.015-13.428-13.428s6.011-13.428,13.428-13.428h69.113 c7.417,0,13.428,6.015,13.428,13.428S450.545,241.706,443.128,241.706z"
              />
              <path
                d="M130.62,452.052c-33.916,0-61.507-27.591-61.507-61.511c0-33.913,27.591-61.504,61.507-61.504s61.507,27.591,61.507,61.504 C192.127,424.461,164.536,452.052,130.62,452.052z M130.62,355.894c-19.107,0-34.651,15.54-34.651,34.647 s15.544,34.654,34.651,34.654s34.651-15.547,34.651-34.654S149.727,355.894,130.62,355.894z"
              />
              <path
                d="M443.128,403.97H227.407c-7.417,0-13.428-6.015-13.428-13.428c0-7.413,6.011-13.428,13.428-13.428h215.721 c7.417,0,13.428,6.015,13.428,13.428C456.556,397.955,450.545,403.97,443.128,403.97z"
              />
              <path
                d="M82.541,403.97H13.428C6.011,403.97,0,397.955,0,390.541c0-7.413,6.011-13.428,13.428-13.428h69.113 c7.417,0,13.428,6.015,13.428,13.428C95.969,397.955,89.958,403.97,82.541,403.97z"
              />
            </g>
          </svg>
        </NavLink>
      </nav>
      <nav
        v-else-if="agency && !oppNav"
        class="mt-5 flex-1 px-4 bg-white space-y-1"
      >
        <NavLink
          path="/agency/our-public-profiles"
          label="Our public profiles"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="m446.605 124.392-119.997-119.997c-2.801-2.802-6.624-4.395-10.608-4.395h-210c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45v-332c0-4.09-1.717-7.931-4.395-10.608zm-115.605-73.179 68.787 68.787h-53.787c-8.271 0-15-6.729-15-15zm75 430.787h-300c-8.271 0-15-6.729-15-15v-422c0-8.271 6.729-15 15-15h195v75c0 24.813 20.187 45 45 45h75v317c0 8.271-6.729 15-15 15z"
              />
              <path
                d="m346 212h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
              <path
                d="m346 272h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
              <path
                d="m346 332h-180c-8.284 0-15 6.716-15 15s6.716 15 15 15h180c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
              <path
                d="m286 392h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
            </g>
          </svg>
        </NavLink>

        <NavLink
          path="/agency/find-partners"
          label="Find partners"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M141.367,116.518c-7.384-7.39-19.364-7.39-26.748,0c-27.416,27.416-40.891,65.608-36.975,104.79 c0.977,9.761,9.2,17.037,18.803,17.037c0.631,0,1.267-0.032,1.898-0.095c10.398-1.04,17.983-10.316,16.943-20.707 c-2.787-27.845,6.722-54.92,26.079-74.278C148.757,135.882,148.757,123.901,141.367,116.518z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M216.276,0C97.021,0,0,97.021,0,216.276s97.021,216.276,216.276,216.276s216.276-97.021,216.276-216.276 S335.53,0,216.276,0z M216.276,394.719c-98.396,0-178.443-80.047-178.443-178.443S117.88,37.833,216.276,37.833 c98.39,0,178.443,80.047,178.443,178.443S314.672,394.719,216.276,394.719z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M506.458,479.71L368.999,342.252c-7.39-7.39-19.358-7.39-26.748,0c-7.39,7.384-7.39,19.364,0,26.748L479.71,506.458 c3.695,3.695,8.531,5.542,13.374,5.542c4.843,0,9.679-1.847,13.374-5.542C513.847,499.074,513.847,487.094,506.458,479.71z"
                />
              </g>
            </g>
          </svg>
        </NavLink>

        <NavLink
          path="/agency/our-directory"
          label="Our directory"
          v-on:clearSearch="clearSearch($event)"
        >
          <svg
            class="nav-icon"
            height="424pt"
            viewBox="0 -25 424 424"
            width="424pt"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m167.289062 272.132812c-1.601562 0-3.214843-.550781-4.53125-1.671874l-45.296874-38.570313c-1.5625-1.332031-2.460938-3.277344-2.460938-5.332031 0-2.050782.902344-3.996094 2.460938-5.328125l45.296874-38.570313c2.941407-2.507812 7.359376-2.152344 9.867188.789063 2.503906 2.945312 2.152344 7.363281-.792969 9.867187l-39.035156 33.242188 39.035156 33.242187c2.945313 2.507813 3.296875 6.925781.792969 9.867188-1.386719 1.628906-3.355469 2.464843-5.335938 2.464843zm0 0"
            />
            <path
              d="m256.710938 272.132812c-1.980469 0-3.949219-.835937-5.332032-2.464843-2.507812-2.941407-2.152344-7.359375.789063-9.867188l39.035156-33.242187-39.035156-33.242188c-2.941407-2.503906-3.296875-6.921875-.789063-9.867187 2.503906-2.941407 6.925782-3.296875 9.863282-.789063l45.296874 38.570313c1.5625 1.332031 2.460938 3.277343 2.460938 5.328125 0 2.054687-.898438 4-2.460938 5.332031l-45.296874 38.570313c-1.316407 1.121093-2.929688 1.671874-4.53125 1.671874zm0 0"
            />
            <path
              d="m195.964844 301.0625c-.480469 0-.964844-.050781-1.453125-.152344-3.78125-.796875-6.203125-4.511718-5.40625-8.292968l28.230469-134.035157c.796874-3.78125 4.507812-6.203125 8.292968-5.40625 3.78125.796875 6.203125 4.507813 5.40625 8.292969l-28.230468 134.035156c-.695313 3.296875-3.601563 5.558594-6.839844 5.558594zm0 0"
            />
            <path
              d="m377 374.085938h-330c-25.914062 0-47-21.082032-47-47v-280.085938c0-25.914062 21.085938-47 47-47h330c25.914062 0 47 21.085938 47 47v280.085938c0 25.917968-21.085938 47-47 47zm-330-360.085938c-18.195312 0-33 14.804688-33 33v280.085938c0 18.195312 14.804688 33 33 33h330c18.195312 0 33-14.804688 33-33v-280.085938c0-18.195312-14.804688-33-33-33zm0 0"
            />
            <path
              d="m417 112.089844h-410c-3.867188 0-7-3.132813-7-7 0-3.863282 3.132812-7 7-7h410c3.867188 0 7 3.136718 7 7 0 3.867187-3.132812 7-7 7zm0 0"
            />
            <path
              d="m119.601562 78.59375c-12.210937 0-22.152343-9.941406-22.152343-22.152344 0-12.214844 9.941406-22.152344 22.152343-22.152344 12.214844 0 22.152344 9.9375 22.152344 22.152344 0 12.210938-9.9375 22.152344-22.152344 22.152344zm0-30.304688c-4.492187 0-8.152343 3.65625-8.152343 8.152344s3.660156 8.152344 8.152343 8.152344c4.496094 0 8.152344-3.65625 8.152344-8.152344s-3.65625-8.152344-8.152344-8.152344zm0 0"
            />
            <path
              d="m51.539062 78.378906c-12.214843 0-22.152343-9.9375-22.152343-22.152344 0-12.214843 9.9375-22.152343 22.152343-22.152343 12.214844 0 22.152344 9.9375 22.152344 22.152343 0 12.214844-9.9375 22.152344-22.152344 22.152344zm0-30.304687c-4.492187 0-8.152343 3.660156-8.152343 8.152343 0 4.496094 3.660156 8.152344 8.152343 8.152344 4.496094 0 8.152344-3.65625 8.152344-8.152344 0-4.492187-3.65625-8.152343-8.152344-8.152343zm0 0"
            />
            <path
              d="m187.664062 78.804688c-12.210937 0-22.148437-9.9375-22.148437-22.152344 0-12.210938 9.9375-22.148438 22.148437-22.148438 12.214844 0 22.152344 9.9375 22.152344 22.148438 0 12.214844-9.9375 22.152344-22.152344 22.152344zm0-30.304688c-4.492187 0-8.148437 3.65625-8.148437 8.152344s3.65625 8.152344 8.148437 8.152344c4.496094 0 8.152344-3.65625 8.152344-8.152344s-3.65625-8.152344-8.152344-8.152344zm0 0"
            />
          </svg>
        </NavLink>

        <ul class="sublinks">
          <li class="sublink">
            <router-link
              active-class="is-active"
              to="/agency/our-directory/manage-partners"
              @click.native="clearSearch('managePartners')"
              class="subnav-item"
            >
              Manage partners
            </router-link>
          </li>
          <li
            v-if="$store.getters.agencyProfile.matchMakerFlag"
            class="sublink"
          >
            <router-link
              active-class="is-active"
              to="/agency/our-directory/matchmaking"
              @click.native="clearSearch('matchmaking')"
              class="subnav-item"
            >
              Matchmaking requests
            </router-link>
          </li>
          <li class="sublink">
            <router-link
              active-class="is-active"
              to="/agency/our-directory/settings"
              @click.native="clearSearch('settings')"
              class="subnav-item"
            >
              Directory settings
            </router-link>
          </li>
        </ul>
      </nav>
      <nav
        v-else
        class="mt-5 flex-1 px-4 bg-white space-y-1"
        aria-label="Sidebar"
      >
        <NavLink
          :path="`/agency/our-public-profiles/${this.$route.params.id}`"
          label="Profile"
        />
        <NavLink
          v-if="$store.state[''].ourPublicProfilesDetail.profile.leadsEnabled"
          :path="`/agency/our-public-profiles/leads/${this.$route.params.id}`"
          label="Leads"
        />
      </nav>
    </div>
    <span
      class="beamerTriggerClass"
      style="display: flex; margin-right: 6rem; font-size: 0.8rem; padding: 2px 24px 12px 0; justify-content: flex-end;"
      >What's new</span
    >
    <div
      class="flex-shrink-0 flex border-t border-solid border-gray-200 p-4 pb-6 cursor-pointer"
      v-click-outside="closeMenu"
      @click="menuOpen = !menuOpen"
    >
      <a class="flex-shrink-0 w-full group block">
        <div class="flex items-center">
          <div>
            <svg
              class="inline-block h-9 w-9 rounded-full"
              fill="#374151"
              height="512pt"
              viewBox="0 0 512 512"
              width="512pt"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469-68.382812 0-132.667969 26.628906-181.019531 74.980469-48.351563 48.351562-74.980469 112.636719-74.980469 181.019531 0 68.378906 26.628906 132.667969 74.980469 181.019531 48.351562 48.351563 112.636719 74.980469 181.019531 74.980469 68.378906 0 132.667969-26.628906 181.019531-74.980469 48.351563-48.351562 74.980469-112.640625 74.980469-181.019531 0-68.382812-26.628906-132.667969-74.980469-181.019531zm-308.679687 367.40625c10.707031-61.648438 64.128906-107.121094 127.660156-107.121094 63.535156 0 116.953125 45.472656 127.660156 107.121094-36.347656 24.972656-80.324218 39.613281-127.660156 39.613281s-91.3125-14.640625-127.660156-39.613281zm46.261718-218.519531c0-44.886719 36.515626-81.398438 81.398438-81.398438s81.398438 36.515625 81.398438 81.398438c0 44.882812-36.515626 81.398437-81.398438 81.398437s-81.398438-36.515625-81.398438-81.398437zm235.042969 197.710937c-8.074219-28.699219-24.109375-54.738281-46.585937-75.078125-13.789063-12.480469-29.484375-22.328125-46.359375-29.269531 30.5-19.894531 50.703125-54.3125 50.703125-93.363281 0-61.425782-49.976563-111.398438-111.402344-111.398438s-111.398438 49.972656-111.398438 111.398438c0 39.050781 20.203126 73.46875 50.699219 93.363281-16.871093 6.941406-32.570312 16.785156-46.359375 29.265625-22.472656 20.339844-38.511718 46.378906-46.585937 75.078125-44.472657-41.300781-72.355469-100.238281-72.355469-165.574219 0-124.617188 101.382812-226 226-226s226 101.382812 226 226c0 65.339844-27.882812 124.277344-72.355469 165.578125zm0 0"
              />
            </svg>
          </div>
          <div class="ml-3">
            <p
              class="text-sm font-semibold text-gray-700 group-hover:text-gray-900"
            >
              {{ user.firstName + ' ' + user.lastName }}
            </p>
            <p
              class="text-xs font-medium text-gray-500 group-hover:text-gray-700"
            >
              Account settings
            </p>
          </div>
        </div>
      </a>
    </div>
    <div
      v-if="menuOpen"
      style="left: 18.5rem; bottom: 1rem; z-index: 999"
      class="origin-top-right absolute bottom-0 left-72 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
    >
      <div class="px-4 py-3" style="border-bottom: 1px solid #ddd">
        <p class="text-sm font-semibold">
          {{ companyName }}
        </p>
        <p class="text-sm font-medium text-gray-900 truncate">
          {{ user.email }}
        </p>
      </div>
      <div
        class="py-1 flex items-center"
        style="border-bottom: 1px solid #ddd"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <button
          @click="$router.push('/account/name')"
          class="signout-button font-semibold flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          role="menuitem"
        >
          <svg
            class="block mr-2 inline-block h-9 w-9 rounded-full"
            fill="#374151"
            style="width: 16px; height: 16px;"
            height="512pt"
            viewBox="0 0 512 512"
            width="512pt"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m437.019531 74.980469c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469-68.382812 0-132.667969 26.628906-181.019531 74.980469-48.351563 48.351562-74.980469 112.636719-74.980469 181.019531 0 68.378906 26.628906 132.667969 74.980469 181.019531 48.351562 48.351563 112.636719 74.980469 181.019531 74.980469 68.378906 0 132.667969-26.628906 181.019531-74.980469 48.351563-48.351562 74.980469-112.640625 74.980469-181.019531 0-68.382812-26.628906-132.667969-74.980469-181.019531zm-308.679687 367.40625c10.707031-61.648438 64.128906-107.121094 127.660156-107.121094 63.535156 0 116.953125 45.472656 127.660156 107.121094-36.347656 24.972656-80.324218 39.613281-127.660156 39.613281s-91.3125-14.640625-127.660156-39.613281zm46.261718-218.519531c0-44.886719 36.515626-81.398438 81.398438-81.398438s81.398438 36.515625 81.398438 81.398438c0 44.882812-36.515626 81.398437-81.398438 81.398437s-81.398438-36.515625-81.398438-81.398437zm235.042969 197.710937c-8.074219-28.699219-24.109375-54.738281-46.585937-75.078125-13.789063-12.480469-29.484375-22.328125-46.359375-29.269531 30.5-19.894531 50.703125-54.3125 50.703125-93.363281 0-61.425782-49.976563-111.398438-111.402344-111.398438s-111.398438 49.972656-111.398438 111.398438c0 39.050781 20.203126 73.46875 50.699219 93.363281-16.871093 6.941406-32.570312 16.785156-46.359375 29.265625-22.472656 20.339844-38.511718 46.378906-46.585937 75.078125-44.472657-41.300781-72.355469-100.238281-72.355469-165.574219 0-124.617188 101.382812-226 226-226s226 101.382812 226 226c0 65.339844-27.882812 124.277344-72.355469 165.578125zm0 0"
            />
          </svg>
          <span>My account</span>
        </button>
      </div>
      <div
        class="py-1 flex items-center"
        style="border-bottom: 1px solid #ddd"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <button
          @click="$router.push('/account/team')"
          class="font-semibold flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          role="menuitem"
        >
          <svg
            class="block mr-2 inline-block h-5 w-5 rounded-full"
            x="0px"
            y="0px"
            viewBox="0 0 505.4 505.4"
            style="enable-background:new 0 0 505.4 505.4;"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M437.1,233.45c14.8-10.4,24.6-27.7,24.6-47.2c0-31.9-25.8-57.7-57.7-57.7c-31.9,0-57.7,25.8-57.7,57.7 c0,19.5,9.7,36.8,24.6,47.2c-12.7,4.4-24.3,11.2-34.1,20c-13.5-11.5-29.4-20.3-46.8-25.5c21.1-12.8,35.3-36.1,35.3-62.6 c0-40.4-32.7-73.1-73.1-73.1c-40.4,0-73.1,32.8-73.1,73.1c0,26.5,14.1,49.8,35.3,62.6c-17.2,5.2-32.9,13.9-46.3,25.2 c-9.8-8.6-21.2-15.3-33.7-19.6c14.8-10.4,24.6-27.7,24.6-47.2c0-31.9-25.8-57.7-57.7-57.7s-57.7,25.8-57.7,57.7 c0,19.5,9.7,36.8,24.6,47.2C28.5,247.25,0,284.95,0,329.25v6.6c0,0.2,0.2,0.4,0.4,0.4h122.3c-0.7,5.5-1.1,11.2-1.1,16.9v6.8 c0,29.4,23.8,53.2,53.2,53.2h155c29.4,0,53.2-23.8,53.2-53.2v-6.8c0-5.7-0.4-11.4-1.1-16.9H505c0.2,0,0.4-0.2,0.4-0.4v-6.6 C505.2,284.85,476.8,247.15,437.1,233.45z M362.3,186.15c0-23,18.7-41.7,41.7-41.7s41.7,18.7,41.7,41.7 c0,22.7-18.3,41.2-40.9,41.7c-0.3,0-0.5,0-0.8,0s-0.5,0-0.8,0C380.5,227.45,362.3,208.95,362.3,186.15z M194.9,165.35 c0-31.5,25.6-57.1,57.1-57.1s57.1,25.6,57.1,57.1c0,30.4-23.9,55.3-53.8,57c-1.1,0-2.2,0-3.3,0c-1.1,0-2.2,0-3.3,0 C218.8,220.65,194.9,195.75,194.9,165.35z M59.3,186.15c0-23,18.7-41.7,41.7-41.7s41.7,18.7,41.7,41.7c0,22.7-18.3,41.2-40.9,41.7 c-0.3,0-0.5,0-0.8,0s-0.5,0-0.8,0C77.6,227.45,59.3,208.95,59.3,186.15z M125.5,320.15H16.2c4.5-42.6,40.5-76,84.2-76.3 c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c20.8,0.1,39.8,7.8,54.5,20.3C141.7,279.75,131,298.95,125.5,320.15z M366.8,359.95 c0,20.5-16.7,37.2-37.2,37.2h-155c-20.5,0-37.2-16.7-37.2-37.2v-6.8c0-62.1,49.6-112.9,111.3-114.7c1.1,0.1,2.3,0.1,3.4,0.1 s2.3,0,3.4-0.1c61.7,1.8,111.3,52.6,111.3,114.7V359.95z M378.7,320.15c-5.5-21.1-16-40-30.3-55.6c14.8-12.8,34-20.5,55-20.7 c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c43.7,0.3,79.7,33.7,84.2,76.3H378.7z"
                />
              </g>
            </g>
          </svg>
          <span>Team</span>
        </button>
      </div>
      <div class="py-1">
        <button
          @click="$auth.logout()"
          type="submit"
          class="signout-button font-semibold flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          role="menuitem"
        >
          <svg
            class="block mr-2"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;height: 15px; width: 15px;"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M324.672,33.692c-9.046-2.645-18.525,2.538-21.173,11.585c-2.649,9.046,2.538,18.526,11.585,21.174 C401.846,91.846,465.92,172.113,465.92,267.947c0,115.75-94.17,209.92-209.92,209.92s-209.92-94.17-209.92-209.92 c0-95.63,63.878-176.043,150.835-201.495c9.045-2.648,14.234-12.128,11.585-21.174c-2.648-9.047-12.133-14.232-21.173-11.585 C87.286,62.976,11.947,155.664,11.947,267.947C11.947,402.834,121.101,512,256,512c134.888,0,244.053-109.154,244.053-244.053 C500.053,156.404,425.442,63.188,324.672,33.692z"
                />
              </g>
            </g>
            <g>
              <g>
                <path
                  d="M256,0c-9.425,0-17.067,7.641-17.067,17.067v161.059c0,9.425,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067 V17.067C273.067,7.641,265.425,0,256,0z"
                />
              </g>
            </g>
          </svg>
          <span>Logout</span>
        </button>
        <div class="triangle"></div>
      </div>
    </div>
  </div>
</template>

<script>
import NavLink from '@/components/DesignSystem/SideNavigationLink';
import ClickOutside from 'vue-click-outside';

export default {
  components: {
    NavLink,
  },
  props: {
    data: Object,
    user: Object,
    agency: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    oppNav() {
      return this.agency && this.$route.meta.OurPublicProfilesNav;
    },
    companyName() {
      if (this.$store.state.vendorDashboard) {
        return this.$store.state.vendorDashboard.details.vendorData.name;
      } else if (this.$store.state['']) {
        return this.$store.state[''].agencyProfile.name;
      } else {
        return '';
      }
    },
    rootUrl() {
      return process.env.VUE_APP_ROOT_CLIENT;
    },
    directoryUrl() {
      if (this.agency) {
        return this.$store.getters['settings'].partnerpageUrl;
      }
      return undefined;
    },
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  methods: {
    closeMenu() {
      return (this.menuOpen = false);
    },
    clearSearch(path) {
      window.scrollTo(0, 0);
      if (path.startsWith('/agency')) {
        path = path.slice(7);
      }
      if (path === '/partners') path = 'agencyProfiles';
      if (path === 'matchmaking') path = 'matchmakingRequests';
      let slug = path
        .replace(/-([a-z])/g, function(g) {
          return g[1].toUpperCase();
        })
        .replace(/^\/|\/$/g, '');
      if (this.$store.state.vendorDashboard) {
        // vendor
        let vendorDash = this.$store.state.vendorDashboard[slug];
        if (vendorDash.table && vendorDash.table.filters) {
          for (const [value] of Object.entries(vendorDash.table.filters)) {
            if (value !== '') {
              this.$store.dispatch(slug + '/table/resetQueryAndFilter');
              break;
            }
          }
        } else if (vendorDash.filters) {
          for (const [value] of Object.entries(vendorDash.filters)) {
            if (value !== '') {
              this.$store.dispatch(slug + '/resetQueryAndFilter');
              break;
            }
          }
        } else if (vendorDash.query) {
          this.$store.dispatch(slug + '/resetQuery');
        }
      } else {
        // agency
        let agencyDash = this.$store.state[''][slug];
        if (agencyDash.table && agencyDash.table.filters) {
          for (let filter of agencyDash.table.filters) {
            if (filter.value !== '') {
              this.$store.dispatch(slug + '/table/resetQueryAndFilter');
              break;
            }
          }
        } else if (agencyDash.filters) {
          for (const [value] of Object.entries(agencyDash.filters)) {
            if (value !== '') {
              this.$store.dispatch(slug + '/resetQueryAndFilter');
              break;
            }
          }
        } else if (agencyDash.query) {
          this.$store.dispatch(slug + '/resetQuery');
        }
      }
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
.nav-icon {
  height: 1rem;
  width: 1rem;
  margin: 0 1rem 0 0.5rem;
}

a.nav-item:focus {
  outline: none;
}

a.nav-item:hover {
  opacity: 1;
}

.nav-item:not(.is--active):hover {
  background-color: rgba(77, 72, 232, 0.05);
}

.is--active {
  background-color: rgba(77, 72, 232, 0.1);
  color: rgba(77, 72, 232, 1);

  svg {
    fill: rgba(77, 72, 232, 1);
  }
}

.sublinks {
  font-size: 14px;
  margin: 0 0 0 60px;

  .sublink {
    a {
      color: #4b5563;
      display: block;
      padding: 0.75rem;
      text-decoration: none !important;
      opacity: 1;

      &:focus {
        outline: none;
      }
    }

    a.is-active {
      background-color: rgba(77, 72, 232, 0.1);
      color: rgba(77, 72, 232, 1);
      border-radius: 4px;
    }
  }
}

.sideNavHeight {
  height: calc(100vh - 59px);
}

.triangle {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 14px 24.2px 14px 0;
  border-color: transparent #ffffff transparent transparent;
  position: absolute;
  bottom: 10px;
  left: -12px;
  z-index: -1;
}
</style>
